<template>
    <div class="row">
        <div class="col-md-12 my-5">
            <div class="mb-3 my-5">
                <div class="text-center">
                    <button type="button" class="btn btn-primary btn-md  width_100p mr_10" @click.prevent="downloadSshKey">Download SSH Key</button>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
      export default {
          name: 'DownloadSshKeyPair',
          props: ['closeModal', 'sshRecord'],
          methods: {
            downloadSshKey() {
              const filename = this.sshRecord?.name +'.pem'; // The name of the file to download

              // Create a Blob object from the string
              const blob = new Blob([this.sshRecord?.private_key], { type: 'text/plain' });

              // Create a download link and trigger it
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link); // Clean up the DOM
            },
          }
      }
  </script>
  <style scoped>

  </style>
  